import { Component, OnInit } from '@angular/core';
import { InboxService } from '../../../../../services/inbox/inbox.service';

@Component({
  selector: 'app-inbox-memberships-and-passes',
  templateUrl: './inbox-memberships-and-passes.component.html',
  styleUrls: ['./inbox-memberships-and-passes.component.css']
})
export class InboxMembershipsAndPassesComponent implements OnInit {

  constructor(
    public inboxService: InboxService
  ) {}

  ngOnInit() {
  }

}
